// extracted by mini-css-extract-plugin
export var cards = "contact-module--cards--gCWa8";
export var contactCard = "contact-module--contactCard--cxlK8";
export var contactCard1 = "contact-module--contactCard1--P+MTe";
export var contactContainer = "contact-module--contactContainer--w02W9";
export var container = "contact-module--container--VwYFj";
export var logo = "contact-module--logo--I0iyZ";